<template>
  <div class="input">
    <div v-if="label">
      <label class="fw-bold">{{ label }}</label>
    </div>
    <input
      :autocomplete="type === 'password' ? 'on' : ''"
      class="border rounded"
      :class="cssClass"
      :max="max"
      :min="min"
      :placeholder="placeholder"
      :required="required"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'CustomInput',
  props: {
    label: {
      default: '',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    modelValue: String,
    min: {
      default: '',
      type: String,
    },
    max: {
      default: '',
      type: String,
    },
  },
  setup(props) {
    const cssClass = computed(() => {
      switch (props.type) {
        case 'time':
          return 'time-picker';
        case 'color':
          return 'color-picker';
        default:
          return '';
      }
    });

    return {
      cssClass,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';
input {
  background-color: inherit;
  border-color: $light-grey !important;
  color: inherit;
  font-size: inherit;
  height: 40px;
  outline: none;
  width: 100%;
}

label {
  margin-right: 10px;
}

.input {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  width: inherit;
}

.time-picker {
  width: 120px;
}

.color-picker {
  width: 80px;
}
</style>
